import {
  findItemByItsPropertyValue,
  isLocal,
  getLinkListFromApi,
} from '../../../utility'

const unpackAdvisorDocumentsForBlogArticles = (documents = []) => {
  return documents.map((itemData) => {
    const {
      _meta,
      author = [],
      authors = [],
      bannerSummary = '',
      cardSummary = '',
      date = undefined,
      detailDocument = '',
      time = '',
      title = '',
      types = [],
      keys = [],
      links: { links = [] } = {},
      image: {
        _meta: { mirror: { id: imageId = '', path: imagePath = '' } = {} } = {},
      } = {},
    } = itemData

    return {
      id: _meta?.id || '',
      path: _meta?.path,
      authors: author || authors,
      bannerSummary,
      cardSummary,
      date,
      detailDocument,
      imageId,
      imageUrl: imagePath
        ? `${isLocal() ? '/cti-site' : ''}/binaries/${imagePath}`
        : '',
      linkList: getLinkListFromApi(
        links.filter((l) => l.Link && l.Link.length > 0)
      ),
      time,
      title,
      types,
      keys,
      _meta,
    }
  })
}
function prepareBlogFilterChips(
  taxonomies = [],
  documents
) /*: {key: "advisor-qa",name: "Advisor QA"}[]*/ {
  const allDocumentKeys = documents.reduce(
    (allDocumentKeysAccumulator, document) => {
      // processedFields is from pageApi, keys is from halApi
      const { keys = [] } = document.processedFields || document
      return [...allDocumentKeysAccumulator, ...keys]
    },
    []
  )
  const blogFilterChips = allDocumentKeys.reduce(
    (blogFilterChipsAccumulator, documentKey) => {
      const matchedItem = findItemByItsPropertyValue(
        taxonomies,
        'key',
        documentKey
      )
      if (matchedItem) {
        return [...blogFilterChipsAccumulator, matchedItem]
      }
      return blogFilterChipsAccumulator
    },
    []
  )
  return [...new Set([...blogFilterChips])]
}
function removeSpecialCharacters(string) {
  return string.replace(/[^\w\s]/gi, '')
}
export {
  unpackAdvisorDocumentsForBlogArticles,
  prepareBlogFilterChips,
  removeSpecialCharacters,
}
